import React, { useEffect, useRef, useContext, useState } from 'react'
import MousePosition from 'ol/control/MousePosition'
import { createStringXY } from 'ol/coordinate'
import MapContext from '../Map/MapContext';
import './MousePositionControl.css';
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import { getTool } from '../../utils/toolsHelper';

function MousePositionControl() {
    const mousePositionControlRef = useRef(null)
    const { map } = useContext(MapContext) // instancia del mapa del contexto
    const { config } = useGlobalVariablesContext();
    const [currentZoom, setCurrentZoom] = useState(null);

    const mousePositionTool = getTool(config?.TOOLS, 'mousePositionControl');
    const conf = mousePositionTool?.params;
    if (!mousePositionTool || !conf) { return null }

    const style = {
        bottom: conf.bottom,
        left: conf.left,
        padding: conf.padding,
    }

    useEffect(() => {
        if (!map) return null // Devuelve null si el mapa no está disponible

        const view = map.getView();

        // Establecer el zoom inicial
        setCurrentZoom(view.getZoom());

        // Listener para actualizar el zoom cuando cambie
        const handleZoomChange = () => {
            setCurrentZoom(view.getZoom());
        };

        view.on('change:resolution', handleZoomChange);

        // Función personalizada para formatear solo las coordenadas
        const coordinateFormat = (coordinate) => {
            if (!coordinate) return '';
            const [x, y] = coordinate;
            return `X: ${x.toFixed(6)}, Y: ${y.toFixed(6)}`;
        };

        // Crear el control de coordenadas del ratón
        const mousePositionControlEPSG4326 = new MousePosition({
            coordinateFormat: coordinateFormat,
            projection: 'EPSG:4326',
            className: 'bar-coordenates',
            target: mousePositionControlRef.current
            // placeholder: '&nbsp; ', //texto fuera de coordenadas
        })

        // Agregar el control al mapa
        map.addControl(mousePositionControlEPSG4326)

        return () => {
            // Remover el control al desmontar el componente
            view.un('change:resolution', handleZoomChange);
            map.removeControl(mousePositionControlEPSG4326)
        }
    }, [map])

    return (
        <div className='mouse-position-control' style={style}>
            <div ref={mousePositionControlRef} style={{ display: 'inline' }} />
            {currentZoom !== null && <span style={{ display: 'inline' }}>, Zoom: {currentZoom.toFixed(2)}</span>}
        </div>
    )
}

export default MousePositionControl
